export const SERVER_DATE_FMT = 'YYYY-MM-DD'
export const SERVER_DATETIME_FMT = `${SERVER_DATE_FMT} HH:mm:ss`

export const DATE_FMT = 'MMMM dd, yyyy'

export enum KeyCodes {
  RETURN = 13,
}

export const Currencies = [
  { label: '---', value: '' },
  'AUD',
  'CAD',
  'CHF',
  'CHN',
  'CZK',
  'EUR',
  'GBP',
  'ILS',
  'INR',
  'JPY',
  'MXN',
  'PLN',
  'RUB',
  'UAH',
  'ZAR',
]
